export interface NotificationActor {
  name: string;
  username?: string;
}

type RawSampleActor = string | NotificationActor;

/**
 * Normalizes `AppNotification.sample_actors` at the notification-panel read
 * boundary. The backend contract is `{ name, username? }[]` (the full,
 * deduped actor list, capped at 25), but rows may still arrive as plain
 * strings until the staging backfill (notifications-clubbed-v2 BE branch)
 * finishes — this keeps that legacy tolerance in exactly one place instead
 * of scattering `typeof` checks through the panel components.
 */
export function normalizeSampleActors(actors: RawSampleActor[] | undefined): NotificationActor[] {
  return (actors ?? []).map((actor) => (typeof actor === 'string' ? { name: actor } : actor));
}
